<template>
  <div
    :key="childrenTypeItem.typeId"
    class="title-list-items-box__container"
  >
    <nuxt-link
      class="title-list-items-box__container__link-title link"
      :to="linkTo"
    >
      <i
        v-if="childrenTypeItem.iconName"
        class="icon"
        :class="{ [`icon-${childrenTypeItem.iconName}`]: true }"
      >
        <span class="path1" /><span class="path2" />
      </i>
      {{ childrenTypeItem.typeName }}
    </nuxt-link>
    <nuxt-link
      v-for="service in childrenTypeItem.serviceList"
      :key="service.serviceId"
      class="title-list-items-box__container__link-item"
      :to="{
        name: 'category-category-service',
        params: {
          service: service.serviceId,
          serviceName: service.serviceTitle,
          category: service.typeParentId,
          categoryName: service.typeName
        }
      }"
      @click.native="$emit('changeDropdownMenuStatusHandler', false);$gaLogEvent('首頁', `click_menu_${childrenTypeItem.typeName}`)"
    >
      {{ service.serviceTitle }}
    </nuxt-link>
  </div>
</template>

<script>
export default {
  props: {
    childrenTypeItem: {
      type: Object,
      default: null
    },
    typeParentId: {
      type: Number,
      default: null
    }
  },
  computed: {
    linkTo () {
      if (this.typeParentId !== -999) {
        return { name: 'index-id', params: { id: this.typeParentId, toTop: false, noScroll: false }, query: { tab: this.childrenTypeItem.typeId } }
      } else {
        return { name: 'highlightSection', params: { toTop: false, noScroll: false }, query: { tab: this.childrenTypeItem.typeId } }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title-list-items-box {
  &__container {
    writing-mode: horizontal-tb;
    min-width: 200px;
    max-width: 250px;
    vertical-align: top;
    margin-bottom: 30px;
    margin-right: 30px;
    display: inline-block;
    &__link-title {
      text-decoration: none;
      font-weight: bold;
      font-size: pxTorem(17px);
      position: relative;
      padding-left: 15px;
      line-height: pxTorem(24px);
      display: flex;
      align-items: center;
      color: $color-text-primary;
      cursor: default;
      margin-bottom: 0;
      word-break: break-all;
      &::before {
        content: "";
        background-color: $color-primary;
        position: absolute;
        left: 0px;
        width: 6px;
        height: calc(100% - 4px);
      }
      .icon {
        margin-right: 4px;
      }
      &.link {
        cursor: pointer;
      }
    }
    &__link-item {
      text-decoration: none;
      color: $color-text-primary;
      font-size: pxTorem(15px);
      font-weight: 400;
      margin-top: 12px;
      display: block;
      word-wrap: break-word;
      padding-left: 15px;
      transition: 0.3s;
      &:hover {
        color: $color-primary;
      }
    }
  }
}
</style>
